export { IndexedDBStorage } from './adapters/indexeddb';
export { MemoryStorage } from './adapters/memory';
export { SQLiteStorage } from './adapters/sqlite';
// Deliberately NOT part of StorageAdapter: the calendar cache is local-only
// and must stay unreachable from SyncEngine and from the JSON export.
export { CalendarCache } from './adapters/calendar-cache';
import { IndexedDBStorage } from './adapters/indexeddb';
import { MemoryStorage } from './adapters/memory';
import { SQLiteStorage } from './adapters/sqlite';
/**
 * Factory function to get appropriate storage
 */
export function createStorage(type = 'indexeddb') {
    switch (type) {
        case 'indexeddb':
            return new IndexedDBStorage();
        case 'memory':
            return new MemoryStorage();
        case 'sqlite':
            return new SQLiteStorage();
        default:
            throw new Error(`Unknown storage type: ${type}`);
    }
}
//# sourceMappingURL=index.js.map